import { asArray, asDate, asNumber, asRaw, asString } from './guards'

/** An external account an entrant linked, e.g. their Discord. */
export interface EntrantAccount {
  platform: string
  account_id: string | null
  /** The account's current name on that platform, when the API could get it. */
  display_name: string | null
}

/** Someone who entered a giveaway, as its organiser sees them. */
export class Entrant {
  user_id: number
  username: string | null
  nickname: string | null
  email: string | null
  profile_picture_id: number | null
  entered_at: Date | null
  entries: number
  objectives: number
  /** When they were awarded a prize from this giveaway; null if they didn't win. */
  won_at: Date | null
  /** Keys they were awarded. Empty for prizes that aren't keys. */
  prize_keys: string[]
  accounts: EntrantAccount[]

  constructor(data: unknown = {}) {
    const d = asRaw(data)
    this.user_id = asNumber(d.user_id) ?? 0
    this.username = asString(d.username)
    this.nickname = asString(d.nickname)
    this.email = asString(d.email)
    this.profile_picture_id = asNumber(d.profile_picture_id)
    this.entered_at = asDate(d.entered_at)
    this.entries = asNumber(d.entries) ?? 0
    this.objectives = asNumber(d.objectives) ?? 0
    this.won_at = asDate(d.won_at)
    this.prize_keys = (asArray(d.prize_keys) ?? []).filter(
      (key): key is string => typeof key === 'string' && key !== '',
    )
    this.won_at = asDate(d.won_at)
    this.prize_keys = (asArray(d.prize_keys) ?? []).filter(
      (key): key is string => typeof key === 'string' && key !== '',
    )
    this.accounts = (asArray(d.accounts) ?? []).map((raw) => {
      const a = asRaw(raw)
      return {
        platform: asString(a.platform) ?? '',
        account_id: asString(a.account_id),
        display_name: asString(a.display_name),
      }
    })
  }

  get won(): boolean {
    return this.won_at !== null
  }
}

/** Winners first, earliest win first; everyone else keeps the API's order. */
export function winnersFirst(entrants: Entrant[]): Entrant[] {
  const winners = entrants
    .filter((e) => e.won)
    .sort((a, b) => (a.won_at as Date).getTime() - (b.won_at as Date).getTime())
  return [...winners, ...entrants.filter((e) => !e.won)]
}
